export default __webpack_public_path__ + "static/media/answer_box.3d0479b6.png";